<template>
    <div role="banner">
        <img :src="logoUrl"/>
    </div>
</template>

<script>
    import {MediaUtil} from "@/utils/MediaUtil";

    export default {
        name: 'app-banner',
        data() {
            return {
                logoUrl: MediaUtil.getMediaUrl('misc/logo.png')
            }
        }
    }
</script>
